import React from 'react';
import { Route, Switch } from 'react-router';
import HashtagOverview from './HashtagOverview';
import HashtagDrilldown from './HashtagDrilldown';
import './UserChats.css';

const UserChatsPage = (props) => {
    const { match } = props;

    return (
        <div className="user-chats-container">
            <Switch>
                <Route exact path={`${match.path}/user-chats`} render={(routeProps) => <HashtagOverview {...props} {...routeProps} />} />
                <Route exact path={`${match.path}/user-chats/:hashtag/:groupId`} render={(routeProps) => <HashtagDrilldown {...props} {...routeProps} />} />
            </Switch>
        </div>
    );
};

export default UserChatsPage;
